import CalendarLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-calendar-light.svg';
import ConfettiLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-confetti-light.svg';
import EarningsLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-earnings-light.svg';
import { clsx } from 'clsx';

import './styles.scss';

const ILLUSTRATIONS = {
  confetti: ConfettiLight,
  earnings: EarningsLight,
  calendar: CalendarLight,
} as const;

export type BannerIllustrationName = keyof typeof ILLUSTRATIONS;

export type BannerIllustrationSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

type BannerIllustrationProps = {
  name: BannerIllustrationName;
  size: BannerIllustrationSize;
  className?: string;
};

export const BannerIllustration = ({
  name,
  size,
  className,
}: BannerIllustrationProps) => (
  <img
    src={ILLUSTRATIONS[name]}
    alt=""
    className={clsx(
      'banner-illustration',
      `banner-illustration--${size}`,
      className
    )}
  />
);
